import React, { useState, useEffect, useContext } from 'react';
import {
    AsGrid,
    AsSearchBar,
    mapPageInfo,
    IconDelete,
    AsButton,
    Modal,
    IconEdit,
    IconTick,
    IconClose,
    useModal
} from '@adserve/adserve-react-components';

import {
    CreateOrUpdateCampaignPackage,
    DeleteCampaignPackage,
    ListCampaignPackages,
    QuoteCampaignPackage,
    GetPackages,
    GetAllStations,
    GetReservationTimes
} from '../../../services/DataService';
import { CreateEntity } from '../../../services/CampaignsDataService';
import { GetValue } from '../../../services/CampaignsDataService';
import PlanProgress from '../AirtimePlanning/PlanProgress';

const CreatePackageOrders = ({ campaign, done }) => {
    const [isQuoting, setIsQuoting] = useState(false);
    const [waitMessageText, setWaitMessageText] = useState(0);
    const { addMessage, removeMessage } = useModal();
    const [waitMessageCounter, setWaitMessageCounter] = useState(0);
    const [percentComplete, setPercentComplete] = useState(0);

    const [pleaseWaitId, setPleaseWaitId] = useState(window.newGuid());

    function sleep(milliseconds) {
        return new Promise((resolve) => setTimeout(resolve, milliseconds));
    }
    useEffect(() => {
        if (pleaseWaitId && isQuoting) {
            waitMessages(pleaseWaitId);
        }
    }, [pleaseWaitId, isQuoting]);
    useEffect(() => {
        waitMessages();
    }, [waitMessageCounter]);
    useEffect(() => {
        if (campaign.campaignPackages?.length) quotePackage(campaign.campaignPackages[0].id);
    }, [campaign]);
    const quotePackage = async (id) => {
        const msg = await CreateEntity('WaitMessage', {});

        setPleaseWaitId(msg?.data?.id);
        setIsQuoting(true);
        try {
            QuoteCampaignPackage(id, msg?.data?.id)
                .then(() => {
                    ListCampaignPackages(campaign.id).then((data) => {
                        campaign.campaignPackages = data;

                        setIsQuoting(false);
                        done();
                    });
                })
                .catch((e) => {
                    setIsQuoting(false);
                    addMessage({
                        message: e.response.data
                    });
                    done();
                });
        } catch (e) {
            addMessage({
                message: e.message
            });
        }
    };
    const waitMessages = async () => {
        if (isQuoting) {
            const messg = await GetValue('WaitMessage', pleaseWaitId);
            const progressIdx = messg?.message?.indexOf('Completed');

            let calcPercent = 0;
            if (messg?.message?.includes('Completed')) {
                calcPercent =
                    parseInt(messg?.message?.substring(progressIdx + 10, progressIdx + 13)) /
                    campaign.campaignStations.length;

                setPercentComplete(calcPercent);
            } else {
                setPercentComplete(0);
                setWaitMessageText(messg?.message);
            }

            await sleep(500);
            if (calcPercent < 1) {
                setWaitMessageCounter(waitMessageCounter + 1);
            }
        }
    };
    return <PlanProgress percentComplete={percentComplete} message={waitMessageText}></PlanProgress>;
};
export default CreatePackageOrders;
